<template lang="pug">
#modal-cancelamento-fiscalizacao
    el-dialog(
        :title="$t('mensagens.operacao.listaFiscalizacao.cancelamentoFiscalizacao')",
        width='610px',
        :visible='show',
        @close='closeDialog()'
    )
        el-form(label-position='top', size='small')
            .row
                .col-12
                    el-form-item
                        template(slot='label')
                            span {{ $t('mensagens.operacao.justificativa') }}
                        el-input(
                            v-model='justificativa',
                            :maxlength='255',
                            :placeholder="$t('mensagens.operacao.justificativa')",
                            type='textarea',
                            resize='none',
                            :rows='2'
                        )
        .buttons.center-align
            BaseButton(size='mini', @click='closeDialog()')
                | {{ $t('mensagens.comuns.fechar') }}
            BaseButton(type='primary', size='mini', @click='cancelarFiscalizacao')
                | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import OperacaoLaudoService from '@/services/OperacaoLaudoService.js';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalCancelamentoFiscalizacao',

    components: {
        BaseButton
    },

    emits: ['atualizarListagem'],

    props: {
        idLaudo: {
            type: Number | null,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            justificativa: null
        };
    },

    methods: {
        closeDialog() {
            this.justificativa = null;
            this.$emit('update:show', false);
        },

        async cancelarFiscalizacao() {
            if (this.justificativa == null || this.justificativa.length === 0) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.preenchaJustificativa')
                });
                return;
            }

            const cancelamentoFiscalizacao = {
                justificativa: this.justificativa
            };

            await OperacaoLaudoService.cancelar(this.idLaudo, cancelamentoFiscalizacao)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('mensagens.operacao.listaFiscalizacao.fiscalizacaoCancelada')
                    });
                    this.$emit('atualizarListagem');
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.listaFiscalizacao.cancelarFiscalizacaoFalha')
                    });
                })
                .finally(() => this.closeDialog());
        }
    }
};
</script>

<style lang="scss">
#modal-cancelamento-fiscalizacao {

    .center-align {
        text-align: center;
        justify-content: space-between;
        display: flex;
    }

    h4.mb-4 {
        word-break: break-word;
        font-size: 14px !important;
    }

    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: -20px 0 20px 0;
    }

    .link {
        margin-left: 20px;
        cursor: pointer;

        i {
            display: inline-flex;
            vertical-align: bottom;
            font-style: normal;
            font-size: 13px;
        }
    }

    .margin-p {
        margin-bottom: 0;
    }
}
</style>
